// abilities.js
import { AbilityBuilder, PureAbility } from "@casl/ability";
import { RETURN_LABEL } from "@pages/Credits/constants.ts";

/***
 * Ability Types
 * keep track of actions and subjects
 */
export type Actions =
  "view" | "manage" | "add" | "assign" | "bulkImport" | "filter";

/**
 * Subject Types
 * The components we want to have access to the ability
 */
export type Subjects =
  | "Account"
  | "Team"
  | "Clients"
  | "all"
  | "Notifications"
  | "EmailNotificationPreferences"
  | "ClientEmailNotificationPreferences"
  | "ClientReminderPreferences"
  | "Summary"
  | "Organizer"
  | "Engagement Letter"
  | "Returns"
  | "TeamMembersTable"
  | "ActionButtons"
  | "TransactionHistoryTable"
  | "Billing";

/**
 * Ability
 * The ability to be used in the application
 */
export const appAbility = PureAbility<[Actions, Subjects]>;
export type AppAbility = PureAbility<[Actions, Subjects]>;
export const defineAbilitiesFor = (role: any) => {
  const { can, cannot, build } = new AbilityBuilder(appAbility);

  switch (role) {
    case "owner":
      can("manage", "all"); // Owner can do everything
      break;
    case "team_member":
      can("view", "Account");

      cannot("assign", "Clients");
      cannot("view", "EmailNotificationPreferences");
      cannot("view", "Notifications");
      cannot("view", "ClientEmailNotificationPreferences");
      cannot("view", "ClientReminderPreferences");
      cannot("bulkImport", "Clients");
      cannot("view", "Organizer");
      cannot("view", "Engagement Letter");
      cannot("filter", "Clients");
      cannot("view", "Summary");

      // Credit Management
      can("view", `${RETURN_LABEL}s`);
      cannot("view", "TeamMembersTable");
      cannot("view", "ActionButtons");
      cannot("view", "TransactionHistoryTable");
      break;
    case "team_lead":
      can("view", "Account");
      can("view", "Team");
      can("add", "Team");
      can("view", "Notifications");
      can("view", "EmailNotificationPreferences");
      can("assign", "Clients");
      can("filter", "Clients");
      can("view", "Summary");

      cannot("view", "ClientEmailNotificationPreferences");
      cannot("view", "ClientReminderPreferences");
      cannot("bulkImport", "Clients");
      cannot("view", "Organizer");
      cannot("view", "Engagement Letter");

      // Credit Management
      can("view", `${RETURN_LABEL}s`);
      cannot("view", "TeamMembersTable");
      cannot("view", "ActionButtons");
      cannot("view", "TransactionHistoryTable");
      break;
    default:
      // Provide minimal permissions for unknown/null roles
      // At minimum, always allow Account view in settings
      can("view", "Account");
      break;
  }

  return build();
};
